import { render, staticRenderFns } from "./ExpensesForm.vue?vue&type=template&id=16d2c32a"
import script from "./ExpensesForm.vue?vue&type=script&lang=js"
export * from "./ExpensesForm.vue?vue&type=script&lang=js"
import style0 from "./ExpensesForm.vue?vue&type=style&index=0&id=16d2c32a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports